const CalenderIcon = ({ className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_141_2351)">
        <path
          d="M12 1.46326V2.79659M4 1.46326V2.79659"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99699 8.79657H8.00297M7.99699 11.4632H8.00297M10.6607 8.79657H10.6666M5.33331 8.79657H5.33929M5.33331 11.4632H5.33929"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.33331 5.46326H13.6666"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66669 8.29208C1.66669 5.3872 1.66669 3.93477 2.50143 3.03234C3.33618 2.12991 4.67968 2.12991 7.36669 2.12991H8.63335C11.3204 2.12991 12.6639 2.12991 13.4986 3.03234C14.3334 3.93477 14.3334 5.3872 14.3334 8.29208V8.63442C14.3334 11.5393 14.3334 12.9917 13.4986 13.8942C12.6639 14.7966 11.3204 14.7966 8.63335 14.7966H7.36669C4.67968 14.7966 3.33618 14.7966 2.50143 13.8942C1.66669 12.9917 1.66669 11.5393 1.66669 8.63442V8.29208Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 5.46326H14"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_2351">
          <rect width="16" height="16" fill="white" transform="translate(0 0.129913)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalenderIcon;
